"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterParent = function FooterParent() {
  return _react2.default.createElement(
    "div",
    { className: "footer-parent" },
    _react2.default.createElement(
      "a",
      {
        href: "https://www.reddit.com/code/",
        title: "snew-classic-ui design forked from reddit",
        style: {
          textAlign: "center",
          display: "inline-block",
          background: "white",
          marginTop: "1em",
          border: "1px solid black"
        }
      },
      _react2.default.createElement(
        "h3",
        { style: { color: "black" } },
        "Interface Design"
      ),
      _react2.default.createElement("img", {
        alt: "Interface Design Powered by reddit.",
        src: "https://s3.amazonaws.com/sp.reddit.com/powered_by_reddit.png",
        style: {
          width: 140,
          height: 47
        }
      })
    ),
    _react2.default.createElement(
      "p",
      { className: "bottommenu" },
      "REDDIT and the ALIEN Logo are registered trademarks of reddit inc."
    )
  );
};

exports.default = FooterParent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/FooterParent.js
// module id = 312
// module chunks = 0